/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line spaced-comment
/// <reference types="@types/google.maps" />
import React, { useEffect, useRef, useState } from 'react';
import { GOOGLE_MAP_PLACEHOLDER_COORDS } from '@/constants';
import styled from 'styled-components';

import theme from '../theme';

export const MARKER_SYMBOLS = [
  {
    fillColor: theme.blue6,
    scale: 9,
  },
  {
    fillColor: 'white',
    scale: 4,
  },
];

export interface ListingMapViewProps {
  coordinates?: [number, number];
}

const ListingMapView: React.FC<ListingMapViewProps> = ({
  coordinates = GOOGLE_MAP_PLACEHOLDER_COORDS,
}) => {
  const mapRef = useRef<HTMLDivElement>(null);

  const [googleMap, setGoogleMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (mapRef.current && !googleMap) {
      const gMap = new google.maps.Map(mapRef.current, {
        center: new google.maps.LatLng(coordinates[1], coordinates[0]),
        zoom: 16,
        mapTypeId: 'terrain',
        // Disable user control
        disableDefaultUI: true,
        clickableIcons: false,
        disableDoubleClickZoom: true,
        draggable: false,
        keyboardShortcuts: false,
        maxZoom: 17,
      });

      MARKER_SYMBOLS.forEach(symbol => {
        const gMarker = new google.maps.Marker({
          position: new google.maps.LatLng(coordinates[1], coordinates[0]),
          icon: {
            path: 0,
            fillOpacity: 1,
            strokeWeight: 0,
            anchor: new google.maps.Point(0, 0),
            ...symbol,
          },
          clickable: false,
        });

        gMarker.setMap(gMap);
      });

      setGoogleMap(gMap);
    }
  }, [mapRef, googleMap]);

  return (
    <StyledTourMapContainer data-cy="tour-map-container">
      <StyledMapDiv ref={mapRef} />
    </StyledTourMapContainer>
  );
};

export default ListingMapView;

const StyledTourMapContainer = styled.div`
  height: 30vh;
  margin-bottom: 20px;
`;

const StyledMapDiv = styled.div`
  width: 100%;
  height: 100%;
`;
